import React from "react"

const Icon: React.FC<{ name: string, type?: "icon" | "brand", className?: string }> = ({ name, type="icon", className }) => {

    return (
        <span className={`${type}${className ? " " + className : ""}`}>{name}</span>
    )
}


export default React.memo(Icon)
